import React, { useEffect } from 'react'
import { useMappedState, useDispatch } from 'redux-react-hook';
import 'react-toastify/dist/ReactToastify.css';
import Button from '@material-ui/core/Button';
import { ConfirmRodo, FetchRodo } from '../../store/rodo/actions';

const padding = {
    padding: 10
}

const mapState = state => ({
  rodo: state.rodo,
});

const RodoComponent = (props) => {
  const dispatch = useDispatch();
  const { rodo } = useMappedState(mapState);

  useEffect(() => {
    if(!rodo.touched) dispatch(FetchRodo());
  }, []);

    const confirm = () => {
      dispatch(ConfirmRodo());
    }

    return (
        <div>
          <h1>Informacja RODO</h1>
            <h2>RODO, czyli zmiany w przepisach dotyczących ochrony Twoich danych osobowych </h2>
            <div style={padding}>Jako {rodo.name}, w świetle przepisów jesteśmy, administratorem Państwa danych osobowych. Oznacza to,
                że odpowiadamy za ich wykorzystanie w sposób bezpieczny, zgodny z umową oraz obowiązującymi przepisami.</div>
            <div style={padding}>Proszę kliknąć następujący link aby przeczytać treść komunikatu <a href={`rodo-${rodo.company}.pdf`} target='_blank'>TREŚĆ KOMUNIKATU</a></div>
            <div style={padding}><Button variant="raised" color="primary" onClick={confirm}>Potwierdzam zapoznanie się</Button></div>
        </div>
    )
}

export default RodoComponent;


// WEBPACK FOOTER //
// ./src/components/Rodo/RodoComponent.js